import { numberToPrettyString } from '@cian/utils';

import { IOffer, ITax } from '../../../types/offer';

function getTaxRate(tax: ITax): string | undefined {
  if (tax.type === 'noTax') {
    return 'НДС не облагается';
  }

  if (tax.type === 'vat' && typeof tax.rate === 'number') {
    return `включая НДС ${tax.rate}%`;
  }

  return undefined;
}

function formatVatPrice(to?: number | null, from?: number | null): string {
  if (to) {
    return `${numberToPrettyString(to)} ₽`;
  }

  if (from) {
    return `${numberToPrettyString(from)} ₽`;
  }

  return '';
}

export function getVatTypeWithVatPrice(offer: IOffer, isNewTaxDisplayEnabled?: boolean): string | undefined {
  const { bargainTerms, minVatPriceTotalRur, vatPriceTotalRur, minVatPriceTotalPerMonthRur, vatPriceTotalPerMonthRur } =
    offer;
  const tax = bargainTerms?.tax;
  const vatType = bargainTerms?.vatType;

  if (tax && tax.type) {
    return getTaxRate(tax);
  }

  switch (vatType) {
    case 'usn':
      return isNewTaxDisplayEnabled ? 'НДС не облагается' : 'УСН';

    case 'included':
      switch (offer.dealType) {
        case 'sale':
          return `Включая НДС ${formatVatPrice(vatPriceTotalRur, minVatPriceTotalRur)}`;
        case 'rent':
          return `Включая НДС ${formatVatPrice(vatPriceTotalPerMonthRur, minVatPriceTotalPerMonthRur)}`;
        default:
          return 'Включая НДС';
      }

    case 'notIncluded':
      return 'НДС не облагается';

    default:
      return undefined;
  }
}
